<template>
  <div class="relative h-screen flexCol justify-between w-full w-full md:max-w-md mx-auto">
    <TheNuxtIcon name="login.gif" icon-type="img" class="!w-full !h-full absolute z-0 inset-0 object-cover"/>
    <div class="absolute z-0 inset-0 bg-primary-800  opacity-80"></div>
    <TheHeader variant="auth" :title="backwardTitle" :show-profile="false" />
    <div class="flex flex-col bg-black p-6 w-full max-w-screen flex-1 text-gray-100 ">
      <slot/>
    </div>
  </div>
</template>

<script lang="ts" setup>

const backwardTitle = useState<string>('backwardTitle')
</script>
